module.exports = __webpack_public_path__ + "static/media/job-board-preview-1.fb9bbd5b.png";